import React from 'react'
import hero1 from '../components/images/hero-1.jpg';
import hero2 from '../components/images/hero-2.jpg';
import happyGroup from '../components/images/happy-family.jpg'

function HeroCarousel() {
  return (
    <div class="carousel">
      
      <img class="hero-img" src="https://content.acetians.in/uploads/Gemini_Generated_Image_j35zdnj35zdnj35z.png"/>
      <div class="carousel-content">
        <div>
          <p class="line1">Join us on our journey as we plan to emprove the wellness of human kind overall.
          </p>
        </div>
        <div>
            <h1>Innovating Today for a <span class="primary">Healthier&nbsp;Tomorrow</span>
            </h1>
        </div>
      </div>
    </div>
  )
}

export default HeroCarousel